import React, {useState, useEffect} from 'react'
import propTypes from 'prop-types'
import {gql} from "apollo-boost";
import styled from 'styled-components';
import {Grid, Box} from '@material-ui/core';
import qs from 'qs';
import {get} from 'lodash';

import client from '../../../src/graphql/client';
import contentBuilderQuery from '../../../src/graphql/queries/content-builder';
import {theme} from '../../../src/themes/default-theme';
import Icon from '../../../src/assets/icons/newsletter-circle.svg';

import refactorHb from '../../../src/data-restructure/multimedia/hero-banner';
import refactorHBCData from '../../../src/data-restructure/multimedia/hero-banner-carousel';

// components
import Banner from '../../../src/components/multimedia/Banner';
import BannerSlider from '../../../src/components/multimedia/BannerSlider';
import FormContainer from '../../../src/containers/Forms/FormContainer';

const ResultsForm = (props) => {

  const [hiddenFields, updateHiddenFields] = useState([])

  const country = props.countryProps.countryCode === 'AU' ? "Australia's" : "New Zealand's"
  
  useEffect(() => {
    if (process.env.SHOW_PRICING === false) {
      window.location.href = '/';
    }
    const currentQsData = qs.parse(window.location.search.replace('?',''));
    if (!get(currentQsData, 'form_data', null)) {
      const redirectUrl = '/repayments-calculator';
      process.env.NODE_ENV === 'development' ?
        window.location.href = redirectUrl
      :
      Router.push(redirectUrl);
    } else {
      const fields = Object.keys(currentQsData.form_data).map(key => {
        return {
          type:  'hidden',
          name: key,
          value: currentQsData.form_data[key]
        }
      })
      updateHiddenFields(fields);
    }
  }, []);

  const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

  return (
  	<div>
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          headingSize="large"
          mainHeading="Email Results"
        />
      }

      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }

      <FormContainer
        icon={Icon}
        formId="repayment_results"
        thankYouUrl="/repayments-calculator/results/form/thank-you"
        text="Email your repayment results to yourself and save for future reference"
        //title="Some title"
        formItems={[
          ...hiddenFields,
          {
            type: 'name',
            name: 'first_name',
            label: 'first_name',
            placeholder: 'First name*',
            errorText: 'This field is required',
            required: true
          },
          {
            type: 'name',
            name: 'last_name',
            label: 'last_name',
            placeholder: 'Last name*',
            errorText: 'This field is required',
            required: true
          },
          {
            type: 'email',
            name: 'email',
            label: 'email',
            placeholder: 'Email*',
            errorText: 'Please add a valid email address',
            required: true
          },
          {
            type: 'checkbox',
            margin: 'none',
            name: 'e_newsletter',
            label: `Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`,
          },
          {
            type: 'checkbox',
            margin: 'none',
            name: 'privacy',
            label: `I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`,
            errorText: 'This field is required',
            required: true
          }
        ]}
      />

    </div>
  )
}
  
ResultsForm.propTypes = {

}
  
ResultsForm.defaultProps = {

}

export async function getStaticProps() {
  const GET_COMPARE = gql`
    query GET_MODELS($uri: String)  {
      pageBy(uri: $uri) {
        ${contentBuilderQuery()}
      }
    }
  `

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const pageProps = await client.query({
    query: GET_COMPARE,
    variables: {
      uri: `repayments-calculator?${countryCode}`
    }
  });

  const contentBuilderData = get(pageProps, 'data.pageBy.acf_content_builder.contentBuilder', null);

  // First item could be hero banner or hero banner carousel
  // Hero banner
  const hasBanner = get(contentBuilderData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(contentBuilderData[0], 'shb') : null;

  // Banner carousel
  const hasCarousel = get(contentBuilderData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcHeroBannerCarousel';
  const heroBannerCarousel = hasCarousel ? refactorHBCData(contentBuilderData[0]) : null;

  const data = {
    heroBanner,
    heroBannerCarousel
  }

  return {
    props: {
      ...data,
      meta: {
        noIndex: true
      }
    }
  }
}
  
export default ResultsForm